import { activityfeedInitialState } from '@modules/activityfeed/stores/activityfeed.slice'
import { useActivityfeedStore } from '@modules/activityfeed/stores/activityfeed.store'
import { artifactFeedsInitialState } from '@modules/artifact-feeds/stores/artifact-feeds.slice'
import { useArtifactFeedsStore } from '@modules/artifact-feeds/stores/artifact-feeds.store'
import { resetGatewaysState } from '@modules/gateways/stores/gateways.thunks'
import { useProjectsStore } from '@modules/projects/stores/projects.store'

/** Resets client stores scoped to the current workspace (not settings workspace members/notifications). */
export function clearWorkspaceScopedClientStores(): void {
  resetGatewaysState()
  useProjectsStore.getState().resetProjectMembers()
  useActivityfeedStore.getState().setState({ ...activityfeedInitialState })
  useArtifactFeedsStore.getState().setFetchState({ ...artifactFeedsInitialState })
}
